// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_INVENTORY_CATEGORY,
    SETTING_CREATE_INVENTORY_CATEGORY_SUCCESS,
    SETTING_UPDATE_INVENTORY_CATEGORY,
    SETTING_UPDATE_INVENTORY_CATEGORY_SUCCESS,
    SETTING_LOAD_INVENTORY_CATEGORY,
    SETTING_LOAD_INVENTORY_CATEGORY_SUCCESS,
    SETTING_DELETE_INVENTORY_CATEGORY,
    SETTING_DELETE_INVENTORY_CATEGORY_SUCCESS,

    SETTING_LOAD_INVENTORY,
    SETTING_LOAD_INVENTORY_SUCCESS,
    SETTING_CREATE_INVENTORY,
    SETTING_CREATE_INVENTORY_SUCCESS,
    SETTING_UPDATE_INVENTORY,
    SETTING_UPDATE_INVENTORY_SUCCESS,
    SETTING_DELETE_INVENTORY,
    SETTING_DELETE_INVENTORY_SUCCESS,
    // SETTING_UPDATE_INVENTORY_STATUS,
    // SETTING_UPDATE_INVENTORY_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getInventoryCategory --------------------- //
export const getInventoryCategory = (data, token) => ({
    type: SETTING_LOAD_INVENTORY_CATEGORY,
    payload: data,
    token
});
export const getInventoryCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_INVENTORY_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createInventoryCategory --------------------- //
export const addInventoryCategory = (data, token) => ({
    type: SETTING_CREATE_INVENTORY_CATEGORY,
    payload: data,
    token
});
export const addInventoryCategorySuccess = () => ({
    type: SETTING_CREATE_INVENTORY_CATEGORY_SUCCESS,
});

// // -------------------- updateInventoryCategory --------------------- //
export const updateInventoryCategory = (data, token) => ({
    type: SETTING_UPDATE_INVENTORY_CATEGORY,
    payload: data,
    token
});
export const updateInventoryCategorySuccess = () => ({
    type: SETTING_UPDATE_INVENTORY_CATEGORY_SUCCESS,
});

// // -------------------- deleteInventoryCategory --------------------- //
export const deleteInventoryCategory = (data, token) => ({
    type: SETTING_DELETE_INVENTORY_CATEGORY,
    payload: data,
    token
});
export const deleteInventoryCategorySuccess = () => ({
    type: SETTING_DELETE_INVENTORY_CATEGORY_SUCCESS,
});

// // -------------------- getInventory --------------------- //
export const getInventory = (data, token) => ({
    type: SETTING_LOAD_INVENTORY,
    payload: data,
    token
});
export const getInventorySuccess = (data, list) => ({
    type: SETTING_LOAD_INVENTORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createInventory --------------------- //
export const createInventory = (data, token) => ({
    type: SETTING_CREATE_INVENTORY,
    payload: data,
    token
});
export const createInventorySuccess = () => ({
    type: SETTING_CREATE_INVENTORY_SUCCESS,
});

// // -------------------- updateInventory --------------------- //
export const updateInventory = (data, token) => ({
    type: SETTING_UPDATE_INVENTORY,
    payload: data,
    token
});
export const updateInventorySuccess = () => ({
    type: SETTING_UPDATE_INVENTORY_SUCCESS,
});

// // -------------------- deleteInventory --------------------- //
export const deleteInventory = (data, token) => ({
    type: SETTING_DELETE_INVENTORY,
    payload: data,
    token
});
export const deleteInventorySuccess = () => ({
    type: SETTING_DELETE_INVENTORY_SUCCESS,
});

// // -------------------- updateInventory --------------------- //
// export const updateChangeStatusInventory = (data, token) => ({
//     type: SETTING_UPDATE_INVENTORY_STATUS,
//     payload: data,
//     token
// });
// export const updateChangeStatusInventorySuccess = () => ({
//     type: SETTING_UPDATE_INVENTORY_STATUS_SUCCESS,
// });
